import React, { useCallback } from 'react'
import { pdf } from '@react-pdf/renderer'
import { AttachmentIcon } from '@chakra-ui/icons'
import { useParams } from 'react-router-dom'

import {
  Link,
  Flex,
  Stack,
  HStack,
  VStack,
  Button,
  Alert,
  AlertIcon,
  Heading,
  Container
} from '@chakra-ui/react'

import { Page } from 'components'
import { useAuthQuery } from 'modules/auth'
import { useConfigByNameDetailQuery } from 'modules/config'

import { FormSubmissionReportPDF } from '../pdf'
import { useFormSubmissionDetailQuery } from '../hooks'

import {
  ReportScoreCard,
  ReportFormIDCard,
  ReportProjectIDCard,
  ReportRecommendations,
  ReportDimensionalScoreCard,
  ReportLongitudinalScoreCard
} from '../components'

export const renderAnswerValue = ({ value }) => {
  switch (value['type']) {
    case 'bool':
      return value['bool'] ? 'Sim' : 'Não'
    case 'number':
      return value['number']
    case 'options':
      return value['options'].map(({ value }) => value).join(', ')
    default:
      return 'Unknown'
  }
}

export const FormSubmissionReportPage = () => {
  const { formSubmissionId } = useParams()
  const { data: auth } = useAuthQuery()
  const { data, loading } = useFormSubmissionDetailQuery(formSubmissionId)
  const { data: register_form_url } = useConfigByNameDetailQuery('register_form_url')
  const { data: register_form_label } = useConfigByNameDetailQuery('register_form_label')
  const { data: register_form_button_label } = useConfigByNameDetailQuery('register_form_button_label')

  const downloadPDF = useCallback(async () => {
    const blob = await pdf(<FormSubmissionReportPDF auth={auth} data={data} />).toBlob()
    const tempLink = document.createElement('a')
    tempLink.href = URL.createObjectURL(blob)
    tempLink.setAttribute('download', `Relatorio-${formSubmissionId}.pdf`)
    tempLink.click()
  }, [auth, data, formSubmissionId])

  return (
    <Page>
      <Container>
        <VStack align='stretch' spacing={5}>
          <Alert status='info'>
            <AlertIcon />
            <Flex flex={1} alignItems='center' justifyContent='space-between'>
              {register_form_label?.value}
              <Button as={Link} ml={3} size='sm' isExternal href={register_form_url?.value}>
                {register_form_button_label?.value}
              </Button>
            </Flex>
          </Alert>

          <Heading size='2xl' textAlign='center' m={5}>
            Relatório de Avaliação #{formSubmissionId}
          </Heading>

          <HStack justifyContent='flex-end'>
            <Button disabled={loading} onClick={downloadPDF} leftIcon={<AttachmentIcon />}>
              Descarregar PDF
            </Button>
          </HStack>

          <Stack flex={1} spacing={5} align='stretch' direction={{ base: 'column', lg: 'row' }}>
            <ReportFormIDCard flex={2} loading={loading} report={data} auth={auth} />
            <ReportProjectIDCard flex={3} loading={loading} report={data} />
            <ReportScoreCard flex={1} loading={loading} report={data} />
          </Stack>

          <Stack flex={1} spacing={5} align='stretch' direction={{ base: 'column', lg: 'row' }}>
            <ReportLongitudinalScoreCard flex={2} loading={loading} report={data} />
            <ReportDimensionalScoreCard flex={2} loading={loading} report={data} />
          </Stack>

          <VStack align='stretch' spacing={5}>
            <Heading>Recomendaçōes da Avaliação</Heading>
            <ReportRecommendations loading={loading} report={data} />
          </VStack>
        </VStack>
      </Container>
    </Page>
  )
}

export default FormSubmissionReportPage
